import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../../shared/base-service/base-api.service';
import { DriverExaminationResultWithRestriction } from '../models/examination/driver-examination-result-with-restriction.model';
import { DriverExaminationResultVisionReport } from '../models/examination/driver-examination-result-vision-report.model';
import { DriverExaminationViewModel } from '../models/examination/driver-examination-view.model';
import { DriverExaminationResultAnswer } from '../models/examination/driver-examination-result-answer.model';
import {Message} from 'primeng/api';

@Injectable()
export class ExaminationService extends BaseApiService {
    // Gets or sets the messages that will be pushed to the p-growl component
    public growlMessages: Message[] = [];

    constructor() {
        super();
    }

    public getLookups = (driverRequirementTypeId: number): Observable<DriverExaminationViewModel> => this.get('Driver/Examination/Lookups/' + driverRequirementTypeId);

    public getLookupsLimited = (driverRequirementTypeId: number, businessTransactionNumberId: number): Observable<DriverExaminationViewModel> => this.get(`Driver/Examination/Lookups/${driverRequirementTypeId}/${businessTransactionNumberId}`);

    public saveDriverExaminationResult = (businessTransactionId, model: DriverExaminationResultWithRestriction): Observable<any> => this.post(`Driver/Examination/${businessTransactionId}`, model);

    public saveDriverVisionExaminationResult = (businessTransactionId, model: DriverExaminationResultVisionReport): Observable<any> => this.post(`Driver/Examination/Vision/${businessTransactionId}`, model);

    public getDriverExamination = (businessTransactionId: number, driverRequirementTypeId: number): Observable<any> => this.get(`Driver/Examination/${businessTransactionId}/${driverRequirementTypeId}`);

    public getDriverExaminationResult = (driverExaminationResultId: number): Observable<any> => this.get(`Driver/Examination/result/${driverExaminationResultId}`);

    public getDriverVisionExamination = (businessTransactionId: number, driverRequirementTypeId: number): Observable<any> => this.get(`Driver/Examination/Vision/${businessTransactionId}/${driverRequirementTypeId}`);

    public submitDriverExamination = (model: DriverExaminationResultAnswer[]): Observable<any> => this.post('driver/examination/result', model);

    public cancelDriverExamination = (driverExaminationResultId: number): Observable<any> => this.get(`Driver/Examination/CancelDriverExamination/${driverExaminationResultId}`);

    public deleteDriverExamination = (businessTransactionId, model: DriverExaminationResultWithRestriction): Observable<any> => this.delete(`Driver/Examination/${businessTransactionId}/${model.id}`);
}
